import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link as RouterLink } from 'react-router-dom';
import moment from 'moment';
import { DataGrid } from '@mui/x-data-grid';
import { Grid, MenuItem, FormControl, InputLabel, Select, Box, Typography, InputAdornment, Tooltip, Divider, Tabs, Tab, Link } from '@mui/material';
import { toast } from 'react-toastify';
import Button from '../../components/Button';
import TextField from '../../components/TextField';
import { useTheme } from '@mui/material/styles';
import { useStudent } from './hooks';
import { getCourseAssignments } from '../../store/study/studyBaseApi';
import { student as studentConstant } from './constants';
import { getAllWithoutPage } from '../../store/course/courseBaseApi';
import { ArrowBendUpLeft } from '@phosphor-icons/react';
import { StudentActivity } from './StudentActivity';

export const Activity = () => {
    const theme = useTheme();
    const { id } = useParams();
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                padding: '0px 20px',
                [theme.breakpoints.down('md')]: {
                    padding: '0px',
                },
            }}>
            <div className='question header-container'>
                <div className='header'>
                    <Typography
                        align="left"
                        variant="h1"
                        color="primary.blue"
                        sx={{
                            margin: '0',
                            fontWeight: '700',
                            lineHeight: '1.5',
                            fontSize: '2rem',
                        }}>Student Activity</Typography>
                </div>
                <StudentActivity studentId={id} />
                <Box sx={{ mt: 4, display: 'flex', gap: '10px' }}>
                       <Link component={RouterLink} to={`/student/edit/${id}`}>
                        <Button
                            size='large'
                            variant="contained"
                            color="primary"
                            placeholder={'Back'}
                            startIcon={<ArrowBendUpLeft />}
                        />
                    </Link>
                </Box>

            </div>
        </Box >
    )
}

const styles = {
    label: {
        color: 'var(--mui-palette-common-black)',
        fontWeight: 'bold'
    },
    inputLabel: {
        color: 'var(--mui-palette-primary-darkGrey)',
        marginBottom: '5px',
        fontWeight: '600',
        fontSize: '14px'
    },
    gridContainer: {
        mt: 2,
        display: 'flex'
    },
    suggestionBox: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        marginTop: '10px',
    },
    suggestionItem: {
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '2px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px var(--mui-palette-secondary-boxShadow1)',
        backgroundColor: 'var(--mui-palette-gray-lightGrey300)',
    },
    uploadBtn: {
        width: '50px',
        height: '50px',
        borderRadius: '5px',
    },
    hiddenInput: {
        display: 'none',
    }
};